/** @jsxImportSource @emotion/react */
import { useHistory } from 'react-router-dom';

import { FilterSwitchSVG, ListOrMapSVG } from '../Icons';
import useStyles from './styles';

const FilterListMapView = ({
  filterShowHide,
  setFilterShowHide,
  currentView = 'map',
}) => {
  const styles = useStyles();
  const history = useHistory();
  const listOrMap = currentView;

  const handleViewToggle = () => {
    // Navigate based on the new view
    if (listOrMap === 'list') {
      history.push('/recommendations');
    } else {
      history.push('/recommendations/map');
    }
  };

  return (
    <div css={styles.filterviewContainer}>
      <button
        css={styles.filterSwitch}
        onClick={() => {
          setFilterShowHide(filterShowHide === false ? true : false);
        }}
        tabIndex={0}
      >
        <FilterSwitchSVG />
        <span css={styles.filterSwitchText} id="filterSwitchText">
          {filterShowHide ? 'Hide Filters' : 'Show Filters'}
        </span>
        {/* I m Commenting down the below line as of now, cause it is having the static value in upcoming phases we are going to make it as dynamic */}
        {/* <span css={styles.numOfFilters}>7</span> */}
      </button>
      <button
        css={styles.viewListOrMap}
        onClick={handleViewToggle}
        tabIndex={0}
      >
        <ListOrMapSVG listOrMap={listOrMap} />
        <span css={styles.filterViewText} id="filterViewText">
          {listOrMap === 'list' ? 'List View' : 'Map View'}
        </span>
      </button>
    </div>
  );
};

export default FilterListMapView;
